module.exports = __webpack_public_path__ + "img/vip_default_logo.5c6adcf0.png";